<template>
  <div
    :class="{
      'mx-auto max-w-1920px bg-www-color-white px-5 py-4 md:py-10px lg:px-10': true,
    }"
  >
    <!-- desktop menu -->
    <div
      :class="{
        'desktop-header hidden w-full md:flex md:items-center': true,
      }"
    >
      <EduHeaderLogo
        v-if="eduHeaderData"
        v-bind="eduHeaderData"
      />
      <BreadCrumbFromRoute
        :title="pageTitle || ''"
        :class="{
          'ml-4 hidden md:ml-6 md:block lg:ml-10': true,
        }"
      />
      <div
        :class="{
          'ml-auto hidden items-center gap-4': true,
          'md:flex': user,
        }"
      >
        <div
          :class="{
            'welcome-auth-desktop text-12px text-www-color-black': true,
          }"
        >
          Welcome back, {{ user?.firstName }}!
        </div>
        <LinkWithIcon
          _type="generalLink"
          :text="openOnshape.text"
          :link="openOnshape.link"
          icon-name="ptc-sign-in-arrow"
          :class="{
            'button-with-icon rounded bg-www-color-primary-lighter font-ptc-Rajdhani uppercase text-www-color-white': true,
            'hover:bg-www-color-primary hover:text-www-color-white': true,
            'md:text-14px md:leading-6 lg:p-4 lg:text-18px': true,
          }"
        />
      </div>
      <div
        :class="{
          'ml-auto hidden items-center gap-4': true,
          'md:flex': !user,
        }"
      >
        <LinkWithIcon
          _type="generalLink"
          :text="signinButton.text"
          :link="signinButton.link"
          icon-name="ptc-sign-in-arrow"
          :class="{
            'sign-in-button h-full': true,
          }"
        />
        <Button
          :class="{
            'hidden font-ptc-Rajdhani md:block lg:uppercase': true,
            'md:px-1 md:text-14px md:leading-6 lg:px-4': true,
          }"
          :button-props="{
            style: 'primary',
            _type: 'button',
            text: signupButton.text,
            link: signupButton.link,
          }"
        />
      </div>
    </div>
    <!-- mobile menu -->
    <div :class="{ 'mobile-header flex items-center md:hidden': true }">
      <EduHeaderLogo
        v-if="eduHeaderData"
        v-bind="eduHeaderData"
      />
      <div class="ml-auto">
        <button
          :class="{
            'block md:hidden': true,
          }"
          @click="toggleMobilMenu()"
        >
          <PtcIcon
            name="ptc-burger-menu"
            alt="Burger Menu"
            :class="{
              'text-www-color-neutral-medium-dark': true,
            }"
          />
        </button>
      </div>
    </div>
    <!-- EduMobileHeader Component -->
    <EduMobileHeader
      v-bind="eduHeaderData"
      v-model:is-opened="isOpened"
    />
  </div>
</template>

<script lang="ts" setup>
import Button from '~/components/Atoms/Button/Button.vue';
import LinkWithIcon from '~/components/Molecules/UtitlityBarComponent/LinkWithIcon.vue';
import BreadCrumbFromRoute from '~/components/Atoms/BreadCrumb/BreadCrumbFromRoute.vue';
import type { EducationHeader } from '~/sanity/types';
import EduHeaderLogo from '~/components/Organisms/EducationHeader/EduHeaderLogo.vue';
import PtcIcon from '~/components/Atoms/PtcIcon/PtcIcon.vue';
import EduMobileHeader from './EduMobileHeader.vue';

const { user, setParamsForFetch } = useCrossSession();
setParamsForFetch({ params: ['currentUserData'] });

const eduHeaderData = defineProps<EducationHeader & { pageTitle?: string }>();

const isOpened = ref(false);
function toggleMobilMenu() {
  isOpened.value = !isOpened.value;
}
</script>

<style lang="scss">
.sign-in-button {
  color: var(--www-color-primary-lighter) !important;

  span {
    &:first-child {
      display: flex;
      align-items: center;
      gap: 5px;
    }
  }
}

.button-with-icon {
  span {
    &:first-child {
      display: flex;
      align-items: center;
      gap: 5px;
    }
  }
}
</style>
